import { jsxs, jsx } from "react/jsx-runtime";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import '../Grid/Grid.css';/* empty css                */
const checkNumberEnding = (number) => {
  let flag = false;
  const values = ["1", "2", "3", "4"];
  const stringifiedNumberArray = String(number).split("");
  values.forEach((value) => {
    if (stringifiedNumberArray[stringifiedNumberArray.length - 1] === value) {
      flag = true;
    }
  });
  return flag;
};
const plural = (count) => {
  const arrayFromStringCount = String(count).split("");
  if (count === 0 || arrayFromStringCount[arrayFromStringCount.length - 1] === "0") {
    return `${count} оценок`;
  }
  if (count === 1 || arrayFromStringCount[arrayFromStringCount.length - 1] === "1") {
    return `${count} оценка`;
  }
  if (count > 1 && count <= 4 || checkNumberEnding(count)) {
    return `${count} оценки`;
  }
  return `${count} оценок`;
};
const DealerInfoRating = ({ label, items, className }) => {
  if (!items || !items.length) {
    return;
  }
  return /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-dealer-info-rating", className), children: [
    /* @__PURE__ */ jsxs(Typography.Text, { level: "small", color: "dark-light", className: classnames("perxis-auto-dealer-info-rating__label"), children: [
      label,
      ":"
    ] }),
    /* @__PURE__ */ jsx(Row, { gutter: [18, 0], children: items.map((rating) => {
      if (!rating.name || !rating.value) {
        return;
      }
      return /* @__PURE__ */ jsxs(Col, { span: 12, className: classnames("perxis-auto-dealer-info-rating__container"), children: [
        rating.icon && /* @__PURE__ */ jsx(Icon, { name: rating.icon, className: classnames("perxis-auto-dealer-info-rating__icon") }),
        /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", className: classnames("perxis-auto-dealer-info-rating__name"), children: rating.name }),
        /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", className: classnames("perxis-auto-dealer-info-rating__value"), children: rating.value }),
        !!rating.count && /* @__PURE__ */ jsxs(Typography.Text, { level: "small", color: "dark", className: classnames("perxis-auto-dealer-info-rating__counter"), children: [
          "(",
          plural(rating.count),
          ")"
        ] })
      ] }, rating.name);
    }) })
  ] });
};
export {
  DealerInfoRating as default
};
//# sourceMappingURL=DealerInfoRating.js.map
